import { ENDPOINT } from 'api/endPoints/getTopOverrunActivities';

import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemComponentProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { EXTRA_LARGE, LARGE, MEDIUM } from 'components/Dashboards/Reporting/reportingConfig';

export const topOverdueOverrunActivities: IHashmapItemComponentProps = {
    NoPermissionMessage,
    globalFiltersConfig: [
        { key: 'progressMeasurement', name: 'progressMeasurement', defaultValue: null },
        { key: 'milestoneFragnet', name: 'milestoneFragnet', defaultValue: null },
        { key: 'tags', name: 'tags', defaultValue: [] },
        { key: 'activityCodes', name: 'activityCodes', defaultValue: [] },
        { key: 'wbs', name: 'wbs', defaultValue: null },
        { key: 'resourceType', name: 'resourceType', defaultValue: null },
        { key: 'resource', name: 'resource', defaultValue: null },
    ],
    reportStyle: {
        widgetSizesAvailable: {
            medium: MEDIUM,
            large: LARGE,
            extraLarge: EXTRA_LARGE,
        },
        widgetInitialSize: LARGE,
    },
    reportConfig: {
        buttons: {
            narrative: false,
        },
        threeDotMenuOptions: {
            useAutomatedNarrative: true,
        },
        hideNarrativeEditor: true,
    },
    componentKey: 'topOverdueOverrunActivities',
    id: 'TopOverdueOverrunActivities',
    title: 'Delayed Activities',
    endpoint: ENDPOINT,
};
